const newEquipmentType = {
  snackbar: "Su actualización esta completada",
  name: "Tipo de Equipo",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Cliente",
  formTitle: "Nuevo Tipo de Equipo",
  isPump: "¿Es una bomba?",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar"
};
export default newEquipmentType;
